// extracted by mini-css-extract-plugin
export default {"title":"s_-z","warning":"t_-z","sizeOptionsLegendText":"u_-z"};